export default '/static/frontend/ReachDigital/12gobiking/dist/assets/klarna-pay-later-se-338b0768.svg'